export default __webpack_public_path__ + "static/media/GigLinked_Illustrations_band.33bb2706.svg";